import React from 'react';
import { Container, Row, Col } from 'reactstrap';

const Footer = () => {
  return (
    <footer className="footer">
      <Container fluid>
        <Row>
          <Col sm={6}>
            {new Date().getFullYear()} © Saige.
          </Col>
          <Col sm={6}>
            <div className="text-sm-end d-none d-sm-block">
              Developed By: Citadel Analytics
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
